

// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const TenantSelection = ({ onTenantChange, selectedTenant, isGlobal = false }) => {
//   const [tenants, setTenants] = useState([]);

//   useEffect(() => {
//     const fetchTenants = async () => {
//       try {
//         const response = await axios.get("http://localhost:3000/api/orchestrator/tenants");
//         setTenants(response.data.tenants);

//         console.log("Fetched Tenants:", response.data.tenants); //  Debugging log

//         if (isGlobal) {
//           //  Load selected tenant from localStorage for global selection
//           const storedTenant = localStorage.getItem("selectedTenant");
//           if (storedTenant) {
//             onTenantChange(JSON.parse(storedTenant).id);
//           } else if (response.data.tenants.length > 0) {
//             const defaultTenant = response.data.tenants[0];
//             onTenantChange(defaultTenant.id);
//             localStorage.setItem("selectedTenant", JSON.stringify(defaultTenant));
//           }
//         }
//       } catch (error) {
//         console.error("❌ Error fetching tenants:", error);
//       }
//     };

//     fetchTenants();
//   }, [isGlobal]); //  Only re-run if `isGlobal` changes

//   return (
//     <div className="form-group">
//       <label>Select Tenant:</label>
//       <select 
//         value={selectedTenant || ""} 
//         onChange={(e) => onTenantChange(e.target.value)}
//         disabled={tenants.length === 0}  
//       >
//         {tenants.length === 0 ? (
//           <option value="">Loading tenants...</option>
//         ) : (
//           tenants.map((tenant) => (
//             <option key={tenant.id} value={tenant.id}>
//               {tenant.name}
//             </option>
//           ))
//         )}
//       </select>
//     </div>
//   );
// };

// export default TenantSelection;

// 21 03 oncesi
// components/TenantSelection.js
import React from "react";
import { useTenant } from "../../context/TenantContext";

const TenantSelection = ({ onTenantChange, selectedTenant, isGlobal = false }) => {
  const { tenants, fetchTenants } = useTenant(); // Get tenants from context

  return (
    <div className="form-group">
      <label>Select Tenant:</label>
      <select
        value={selectedTenant || ""}
        onChange={(e) => onTenantChange(e.target.value)}
        disabled={tenants.length === 0}
      >
        {tenants.length === 0 ? (
          <option value="">Loading tenants...</option>
        ) : (
          tenants.map((tenant) => (
            <option key={tenant.id} value={tenant.id}>
              {tenant.name}
            </option>
          ))
        )}
      </select>
    </div>
  );
};

export default TenantSelection;

